import { Reducer } from 'redux';

import { IFetchFamilies, ISetFamilies, ISetFamily, TFamily } from '../actions';
import { EventFamily } from '../entities';

export interface IFamiliesState {
  [key: string]: EventFamily;
}
export const defaultFamiliesState = {};

const getFamilyDetail = (family) => ({
  ...family,
  duration: family.events.reduce((acc, e) => acc + e.duration, 0),
  mediasCount: family.events.reduce((acc, e) => acc + e.mediasCount, 0),
  eventsCount: family.events.length || 0,
});

export const familiesReducer: Reducer<IFamiliesState> = (
  state: IFamiliesState = defaultFamiliesState,
  action: ISetFamilies | ISetFamily | IFetchFamilies
): IFamiliesState => {
  switch (action.type) {
    case TFamily.FETCH_FAMILIES:
      return defaultFamiliesState;
    case TFamily.SET_FAMILIES:
      return action.payload
        .map(getFamilyDetail)
        .reduce((acc, p) => ({ ...acc, [p.id]: p }), state);
    case TFamily.SET_FAMILY:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
  }
  return state;
};
